/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'svg-shaper': {
    width: 100.746,
    height: 74.996,
    viewBox: '0 0 26.656 19.843',
    data: '<path pid="0" d="M6.214 0v4.766l-.745.242v14.19l.745-.088h14.092l1.23.142-.47-.056V5.008l-.76-.242V0H6.214zm15.83 5.319V19.31l4.612.532-1.31-13.474-3.302-1.05zm-17.552.006L1.284 6.37 0 19.843l4.492-.53V5.325z"/>'
  }
})
